import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../../query"
import api from "../../client"
import { GetOrderTemplateResponseData } from "../../types/order-template"

const getData = async (uuid: string | undefined) => {
  const { data } = await api.get(`/order-templates/${uuid}`)
  return data
}

export const useOrderTemplateDetail = (uuid: string | undefined):
  QueryObserverBaseResult<GetOrderTemplateResponseData> => {
  const { data, ...props } = useQuery<GetOrderTemplateResponseData>(
    queryKeys.ORDER_TEMPLATE(uuid),
    () => getData(uuid),
    { enabled: Boolean(uuid) }
  )
  return { data, ...props }
}
